<template>
  <div>
    <search-bar-sp
      :preflist="preflistFiltered"
      :options="options"
      :update="update"
      :isSearchBody="isSearchBody"
      @input="isSearchBody = $event"
    />
    <div class="c-container">
      <section class="p-list js-search-list" v-if="isPagerReady && !isMapDisplayFlag">
        <search-area-info class="p-list--area--outline" v-if="isAreaInfoDisplay" :info="areaInfo" />
        <h1>{{searchArea}} {{kind}}一戸建て購入情報</h1>
        <ul class="p-list--condition">
          <li v-for="(item, index) in conditions" :key="index" @click="item.callback();conditions.splice(index,1);isChanged=true;">
            {{item.name}}
            <img :src="require('@/assets/images/proplist-can.png')" />
          </li>
        </ul>
        <div class="p-list--sort">
          <div class="p-list--sort--count">
            {{count}}件
          </div>
          <div class="p-list--sortOrderBlock">
            <div class="p-list--sort--order">
              <h3>表示件数：</h3>
              <div class="u-selectWrapper u-selectWrapper__s">
                <select v-model="options.size" @change="update()">
                  <option value=30 >30件</option>
                  <option value=50 >50件</option>
                  <option value=100 >100件</option>
                </select>
              </div>
            </div>
            <div class="p-list--sort--order">
              <h3>並び替え：</h3>
              <div class="u-selectWrapper">
                <select v-model="options.order" @change="viewTrigger(options.order)">
                  <option v-for="(item, index) in optionList.sort" :key="index" :value="index">{{item.name}}</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <a href="/member/signup" class="c-banner">
          <div class="c-banner__inner">
            <p class="c-banner__title">会員登録をすると…</p>
            <p class="c-banner__text">
              便利な物件並び替え機能が使用できます！<br>
              会員登録はこちらから！
            </p>
          </div>
        </a>

        <search-loading v-if="!isPropReady" />
        <search-list-body
          v-if="isPropReady & proplist.length > 0"
          class="p-list--outline"
          :proplist="proplist"
          :update="update"
          :size="options.size"
          :page="options.page"
          :count="count"
          :mode="mode"
        />
        <section class="p-list__otherList">
          <h3 class="p-list__otherTitle" v-if="sugguestProps[0].list || sugguestProps[1].list" >ほかの条件の物件を見る</h3>
          <search-sugguest-list-body
            v-if="sugguestProps[0].list"
            class="p-list--outline"
            :proplist="sugguestProps[0]"
            :mode="mode"
          />
          <search-sugguest-list-body
            v-if="sugguestProps[1].list"
            class="p-list--outline u-mT50"
            :proplist="sugguestProps[1]"
            :mode="mode"
          />
        </section>
        <section class="p-list__faq">
          <h2 class="p-list__faqTitle">{{pickArea}}にある{{kind}}一戸建て物件についてよくあるご質問</h2>
          <dl class="p-list__faqBlock">
            <dt class="p-list__faqQuestion js-question">Q. {{pickArea}}には{{kind}}一戸建て掲載物件数は何件ですか？</dt>
            <dd class="p-list__faqAnswer js-answer">A. ミツカルで掲載されている{{pickArea}}の{{kind}}一戸建て掲載物件数は{{count}}件です。希望に沿った物件を探すには、価格帯や間取り、駅からの徒歩時間などの条件で物件を絞り込んでください。</dd>
          </dl>
          <dl class="p-list__faqBlock" v-if="type === 1 && cityAverageObject.price">
            <dt class="p-list__faqQuestion js-question">Q. {{this.location.city.name}}の{{kind}}一戸建て物件の平均価格はいくらですか？</dt>
            <dd class="p-list__faqAnswer js-answer">A. {{this.location.city.name}}の{{kind}}一戸建て物件の価格相場は{{cityAverageObject.price}}万円です。</dd>
          </dl>
          <dl class="p-list__faqBlock" v-if="type === 1 && cityAverageObject.layoutList">
            <dt class="p-list__faqQuestion js-question">Q. {{this.location.city.name}}にはどのような間取りの{{kind}}一戸建て物件がありますか？</dt>
            <dd class="p-list__faqAnswer js-answer">A. {{this.location.city.name}}の{{kind}}一戸建て物件で最も多い間取りは{{cityAverageObject.layoutList}}です。</dd>
          </dl>
          <dl class="p-list__faqBlock" v-if="type === 1 && cityAverageObject.priceListByLayout">
            <dt class="p-list__faqQuestion js-question">Q. {{this.location.city.name}}にある{{kind}}一戸建て物件の間取りごとの平均価格はいくらですか？</dt>
            <dd class="p-list__faqAnswer js-answer">A. {{this.location.city.name}}の{{kind}}一戸建て物件の相場価格は、{{cityAverageObject.priceListByLayout}}です。</dd>
          </dl>
          <dl class="p-list__faqBlock" v-if="type === 1 && cityAverageObject.townList">
            <dt class="p-list__faqQuestion js-question">Q. {{this.location.city.name}}の{{kind}}一戸建ては、町名からも絞り込むことができますか？</dt>
            <dd class="p-list__faqAnswer js-answer">A. ミツカルで掲載されている{{this.location.city.name}}の{{kind}}一戸建ては、{{cityAverageObject.townList}}などの町名からも絞り込むことができます。</dd>
          </dl>
          <!-- <dl class="p-list__faqBlock" v-if="type === 1">
            <dt class="p-list__faqQuestion js-question">Q. {{this.location.city.name}}市の近隣では、どの市区郡で{{kind}}一戸建てが掲載されていますか？</dt>
            <dd class="p-list__faqAnswer js-answer">A. ミツカルでは{{this.location.city.name}}市の近隣市区郡は{{cityAverageObject.cityList.join('、')}}などで{{kind}}一戸建てが掲載されています。</dd>
          </dl> -->
        </section>
        <section v-if="citylist.length > 0 && townlist.length === 0 && isPropReady" class="p-list__AreaList">
          <h2 class="p-list__AreaList__heading" >{{storedLocation.pref.name}}の市区町村一覧</h2>
          <ul class="p-list__AreaList__list">
            <li class="p-list__AreaList__list__item" v-for="(item, index) in citylist " :key="index">
              <a :href="`/kodate/${kindMeta}area/${storedLocation.pref.code}/${item.city_code}/`" >{{`${item.city_name}(${+item.count.toLocaleString()})`}}</a>
            </li>
          </ul>
        </section>
        <section v-if="townlist.length > 0 && isPropReady" class="p-list__AreaList">
          <h2 class="p-list__AreaList__heading" >{{storedLocation.city.name}}の町域一覧</h2>
          <ul class="p-list__AreaList__list">
            <li class="p-list__AreaList__list__item" v-for="(item, index) in townlist " :key="index">
              <a :href="`/kodate/${kindMeta}area/${storedLocation.pref.code}/${item.city_code}/${item.town_code}/`" >{{`${item.town_name}(${+item.count.toLocaleString()})`}}</a>
            </li>
          </ul>
        </section>
        <common-breadcrumb class="p-list--breadcrumb--outline" :breadcrumbType="'searchList'" />
        <div v-if="isPropReady & proplist.length === 0" class="p-list--noprops">
          条件に合う物件がありません。条件を変更して再度検索してください。
        </div>

        <common-footer />
      </section>
      <div class="p-map">
        <search-list-google-map
          v-if="isMapReady"
          :center="mapCenterCoordinate"
          :makerList="coordinateList"
          :zoom="zoom"
        />
        <div v-else class="p-map__blank"></div>
      </div>
    </div>
    <div v-if="isChanged && isMobile" class="update-button">
      <common-button
        :callback="resetUrl"
        :title="'更新'"
        :font_size="'14px'"
        :attr=[]
        :bg_red="true"
        :middle="true" />
    </div>
    <button class="p-swapDisplay" v-if="!isSearchBody" @click="onClickMapButton(); ">
      <img v-if="isMapDisplayFlag" src="@/assets/images/icon_list_bullet@2x.png">
      <img v-else src="@/assets/images/icon_map@2x.png">
      <span v-if="!isMapDisplayFlag">地図を表示</span>
      <span v-else>物件リスト</span>
    </button>
    <common-view-limited
      v-if="isViewLimited"
      :isViewLimited="isViewLimited"
      :directLink="directLink"
      @input="isViewLimited = $event"
    />
  </div>
</template>

<script>
import axios from 'axios';

import MixinUtil from '@/plugins/mixin-utils';
import MixinAPI from '@/plugins/mixin-api';
import BehaviorLogMixin from '@/plugins/mixin-behavior-log';
import { AreaSearchKind, AreaSearchType } from '@/utils/areaCodeEnums';
import isMobile from '@/plugins/isMobile';

import selectOptions from '@/assets/json/selectOptions.json';

import SearchLoading from '@/components/search/kodate/SearchLoading';
import SearchBarPc from '@/components/search/kodate/pc/SearchBar';
import SearchBarSp from '@/components/search/kodate/sp/SearchBar';
import SearchListBody from '@/components/search/kodate/SearchListBody';
import SearchSugguestListBody from '@/components/search/kodate/SearchSugguestListBody';
import SearchListGoogleMap from '@/components/parts/SearchListGoogleMap';
import SearchAreaInfo from '@/components/search/kodate/SearchAreaInfo';
import CommonBreadcrumb from '@/components/parts/CommonBreadcrumb';
import CommonFooter from '@/components/parts/CommonFooter';
import CommonViewLimited from '@/components/parts/CommonViewLimited';
import CommonButton from '@/components/parts/button/CommonButton';

const querystring = window.location.search;
const query = [...new URLSearchParams(querystring).entries()]
  .reduce((obj, e) => ({ ...obj, [e[0]]: e[1] }), {});

export default {
  name: 'SearchList',
  mixins: [MixinUtil, MixinAPI, isMobile, BehaviorLogMixin],
  props: ['preflist', 'preflistFiltered', 'townlist', 'citylist', 'isReady'],
  components: {
    SearchLoading,
    SearchBarPc,
    SearchBarSp,
    SearchListBody,
    SearchSugguestListBody,
    SearchListGoogleMap,
    SearchAreaInfo,
    CommonBreadcrumb,
    CommonFooter,
    CommonViewLimited,
    CommonButton,
  },
  data() {
    return {
      mapCenterCoordinate: {
        lat: 0,
        lng: 0,
      },
      initialized: false,
      jsonld: {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: [{
          '@type': 'Question',
          name: '',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '',
          },
        }],
      },
      options: {
        prefcode: '0',
        citycode: '0',
        ask: false,
        byBus: false,
        layout: [],
        priceLow: 0,
        priceHigh: 999999999,
        landAreaLow: 0,
        landAreaHigh: 99999,
        buildingAreaLow: 0,
        buildingAreaHigh: 99999,
        walkin: '999',
        fw: '',
        size: 30,
        order: 0,
        page: 1,
      },
      sugguestProps: [
        {
          kind: null,
          pref_code: null,
          pref_name: '',
          city_code: null,
          city_name: '',
          town_code: null,
          town_name: '',
        },
        {
          kind: null,
          pref_code: null,
          city_code: null,
          town_code: null,
        },
      ],
      conditions: [],
      pager: [],
      isPrev: false,
      isNext: false,
      isFirst: false,
      isLast: false,
      isPropReady: false,
      isMapReady: false,
      isPagerReady: false,
      isAreaInfoDisplay: false,
      isSearchBody: false,
      coordinateList: [],
      areaInfo: {},
      searchArea: '',
      pickArea: '',
      proplist: [],
      isMapDisplayFlag: false,
      isViewLimited: false,
      directLink: false,
      zoom: 11,
      mode: 'prod',
      isChanged: false,
      cityAverageObject: {},
    };
  },
  metaInfo() {
    return this.initialized ? this.jsonldExport(this.jsonld) : null;
  },
  computed: {
    kind() {
      let ret;
      switch (this.$route.meta.kind) {
        case 1:
          ret = '新築';
          break;
        case 2:
          ret = '中古';
          break;
        default:
          ret = '';
          break;
      }
      return ret;
    },
    kindAPI() {
      let ret;
      switch (this.$route.meta.kind) {
        case 1:
          ret = 'newly-house';
          break;
        case 2:
          ret = 'second-hand-house';
          break;
        default:
          ret = '';
          break;
      }
      return ret;
    },
    kindMeta() {
      let ret;
      switch (this.$route.meta.kind) {
        case 1:
          ret = 'shinchiku/';
          break;
        case 2:
          ret = 'chuko/';
          break;
        default:
          ret = '';
          break;
      }
      return ret;
    },
    storedLocation() {
      /* eslint dot-notaion: 0 */
      return this.$store.getters['getLocation'];
    },
    storedSearchHistory() {
      return this.$store.getters['getSearchHistory'];
    },
    isLoggedIn() {
      return this.$store.state.user;
    },
  },
  async created() {
    this.location = await this.storedLocation;
    this.type = this.location.type;
    //  Sugguest Prop list
    let tmp = [];
    if (this.type === 0) {
      // 都道府県
      if (this.$route.meta.kind === 0) {
        // 都県すべて
        this.sugguestProps[0] = {
          kind: 0,
          pref_code: this.storedLocation.pref.code + 1,
          city_code: 0,
          town_code: 0,
        };
        this.sugguestProps[1] = {
          kind: 0,
          pref_code: this.storedLocation.pref.code - 1,
          city_code: 0,
          town_code: 0,
        };

        // １列目
        tmp = await this.getKindPropertyList(3, this.sugguestProps[0].kind, this.sugguestProps[0].pref_code);
        if (!tmp.hit) {
          if (tmp.hit.length > 0) {
            // tmp.lengthが0のとき
            // 1列目 2回目
            this.sugguestProps[0].pref_code = this.storedLocation.pref.code + 2;
            tmp = await this.getPlanePropertyList(3, this.sugguestProps[0].kind, this.sugguestProps[0].pref_code);

            if (tmp.hit) {
              if (tmp.hit.length > 0) {
                // tmpが0の場合listに代入しない
                this.sugguestProps[0].count = tmp.found;
                this.sugguestProps[0].list = tmp.hit;
              }
            }
          }
        } else if (tmp.hit.length > 0) {
          this.sugguestProps[0].count = tmp.found;
          this.sugguestProps[0].list = tmp.hit;
        }

        // ２列目
        tmp = await this.getKindPropertyList(3, this.sugguestProps[1].kind, this.sugguestProps[1].pref_code);
        if (!tmp.hit) {
          // tmp.lengthが0のとき
          // 2列目 2回目
          this.sugguestProps[1].pref_code = this.storedLocation.pref.code + 2;
          tmp = await this.getPlanePropertyList(3, this.sugguestProps[1].kind, this.sugguestProps[1].pref_code);

          if (tmp.hit) {
            if (tmp.hit.length > 0) {
              // tmpが0の場合listに代入しない
              this.sugguestProps[1].count = tmp.found;
              this.sugguestProps[1].list = tmp.hit;
            }
          }
        } else if (tmp.hit.length > 0) {
          this.sugguestProps[1].count = tmp.found;
          this.sugguestProps[1].list = tmp.hit;
        }
      } else if (this.$route.meta.kind === 1) {
        // 都県新築
        this.sugguestProps[0] = {
          kind: 2,
          pref_code: this.storedLocation.pref.code,
          city_code: 0,
          town_code: 0,
        };

        // 1列目 1回目
        tmp = await this.getKindPropertyList(3, this.sugguestProps[0].kind, this.sugguestProps[0].pref_code);
        if (!tmp.hit) {
          // tmp.lengthが0のとき
          this.sugguestProps[0] = {
            kind: this.$route.meta.kind,
            pref_code: this.storedLocation.pref.code + 1,
            city_code: 0,
            town_code: 0,
          };
          this.sugguestProps[1] = {
            kind: this.$route.meta.kind,
            pref_code: this.storedLocation.pref.code - 1,
            city_code: 0,
            town_code: 0,
          };
          // 1列目 2回目
          tmp = await this.getKindPropertyList(3, this.sugguestProps[0].kind, this.sugguestProps[0].pref_code);
          if (tmp.hit) {
            if (tmp.hit.length > 0) {
              // tmp.lengthが0のとき
              // 1列目 3回目
              this.sugguestProps[0].pref_code = this.storedLocation.pref.code + 2;
              tmp = await this.getKindPropertyList(3, this.sugguestProps[0].kind, this.sugguestProps[0].pref_code);
              if (tmp.hit) {
                if (tmp.hit.length > 0) {
                  // tmpが0の場合listに代入しない
                  this.sugguestProps[0].count = tmp.found;
                  this.sugguestProps[0].list = tmp.hit;
                }
              }
            }
          }
          // 2列目 1回目
          tmp = await this.getKindPropertyList(3, this.sugguestProps[1].kind, this.sugguestProps[1].pref_code);
          if (tmp.hit) {
            if (tmp.hit.length > 0) {
              // tmp.lengthが0のとき
              // 2列目 2回目
              this.sugguestProps[1].pref_code = this.storedLocation.pref.code + 2;
              tmp = await this.getKindPropertyList(3, this.sugguestProps[1].kind, this.sugguestProps[1].pref_code);
              if (tmp.hit) {
                if (tmp.hit.length > 0) {
                  // tmpが0の場合listに代入しない
                  this.sugguestProps[1].count = tmp.found;
                  this.sugguestProps[1].list = tmp.hit;
                }
              }
            }
          }
        } else if (tmp.hit.length > 0) {
          this.sugguestProps[0].count = tmp.found;
          this.sugguestProps[0].list = tmp.hit;
        }
      } else if (this.$route.meta.kind === 2) {
        // 都県中古
        this.sugguestProps[0] = {
          kind: 1,
          pref_code: this.storedLocation.pref.code,
          city_code: 0,
          town_code: 0,
        };

        // 1列目 1回目
        tmp = await this.getKindPropertyList(3, this.sugguestProps[0].kind, this.sugguestProps[0].pref_code);
        if (!tmp.hit) {
          // tmp.lengthが0のとき
          this.sugguestProps[0] = {
            kind: this.$route.meta.kind,
            pref_code: this.storedLocation.pref.code + 1,
            city_code: 0,
            town_code: 0,
          };
          this.sugguestProps[1] = {
            kind: this.$route.meta.kind,
            pref_code: this.storedLocation.pref.code - 1,
            city_code: 0,
            town_code: 0,
          };
          // 1列目 2回目
          tmp = await this.getKindPropertyList(3, this.sugguestProps[0].kind, this.sugguestProps[0].pref_code);
          if (tmp.hit) {
            if (tmp.hit.length > 0) {
              // tmp.lengthが0のとき
              // 1列目 3回目
              this.sugguestProps[0].pref_code = this.storedLocation.pref.code + 2;
              tmp = await this.getKindPropertyList(3, this.sugguestProps[0].kind, this.sugguestProps[0].pref_code);
              if (tmp.hit) {
                if (tmp.hit.length > 0) {
                  // tmpが0の場合listに代入しない
                  this.sugguestProps[0].count = tmp.found;
                  this.sugguestProps[0].list = tmp.hit;
                }
              }
            }
          }
          // 2列目 1回目
          tmp = await this.getKindPropertyList(3, this.sugguestProps[1].kind, this.sugguestProps[1].pref_code);
          if (tmp.hit) {
            if (tmp.hit.length > 0) {
              // tmp.lengthが0のとき
              // 2列目 2回目
              this.sugguestProps[1].pref_code = this.storedLocation.pref.code + 2;
              tmp = await this.getKindPropertyList(3, this.sugguestProps[1].kind, this.sugguestProps[1].pref_code);
              if (tmp.hit) {
                if (tmp.hit.length > 0) {
                  // tmpが0の場合listに代入しない
                  this.sugguestProps[1].count = tmp.found;
                  this.sugguestProps[1].list = tmp.hit;
                }
              }
            }
          }
        } else if (tmp.hit.length > 0) {
          this.sugguestProps[0].count = tmp.found;
          this.sugguestProps[0].list = tmp.hit;
        }
      }
    } else if (this.type === 1) {
      // 市区町村
      let cityList = [];
      let sugguestCityList = this.citylist.concat();
      sugguestCityList = sugguestCityList.sort(this.compare);
      sugguestCityList.map((n, m) => {
        if (n.city_code === this.storedLocation.city.code) {
          cityList = [m + 1, m - 1];
        }
        return n;
      });
      if (this.$route.meta.kind === 0) {
        // 市区町村すべて
        this.sugguestProps[0] = {
          kind: 0,
          pref_code: this.storedLocation.pref.code,
          city_code: cityList[0] >= 0 && cityList[0] < sugguestCityList.length ? sugguestCityList[cityList[0]].city_code : 0,
          town_code: 0,
        };
        this.sugguestProps[1] = {
          kind: 0,
          pref_code: this.storedLocation.pref.code,
          city_code: cityList[1] >= 0 && cityList[1] < sugguestCityList.length ? sugguestCityList[cityList[1]].city_code : 0,
          town_code: 0,
        };

        if (this.sugguestProps[0].city_code !== 0) {
          tmp = await this.getKindPropertyList(3, this.sugguestProps[0].kind, this.sugguestProps[0].pref_code, this.sugguestProps[0].city_code);
          if (tmp.hit) {
            if (tmp.hit.length > 0) {
              this.sugguestProps[0].count = tmp.found;
              this.sugguestProps[0].list = tmp.hit;
            }
          }
        }

        if (this.sugguestProps[1].city_code !== 0) {
          tmp = await this.getKindPropertyList(3, this.sugguestProps[1].kind, this.sugguestProps[1].pref_code, this.sugguestProps[1].city_code);
          if (tmp.hit) {
            if (tmp.hit.length > 0) {
              this.sugguestProps[1].count = tmp.found;
              this.sugguestProps[1].list = tmp.hit;
            }
          }
        }
      } else if (this.$route.meta.kind === 1) {
        // 市区町村新築
        this.sugguestProps[0] = {
          kind: 2,
          pref_code: this.storedLocation.pref.code,
          city_code: this.storedLocation.city.code,
          town_code: 0,
        };
        tmp = await this.getKindPropertyList(3, this.sugguestProps[0].kind, this.sugguestProps[0].pref_code, this.sugguestProps[0].city_code);
        if (!tmp.hit) {
          // tmp.lengthが0のとき
          this.sugguestProps[0] = {
            kind: this.$route.meta.kind,
            pref_code: this.storedLocation.pref.code,
            city_code: cityList[0] >= 0 && cityList[0] < sugguestCityList.length ? sugguestCityList[cityList[0]].city_code : 0,
            town_code: 0,
          };
          this.sugguestProps[1] = {
            kind: this.$route.meta.kind,
            pref_code: this.storedLocation.pref.code,
            city_code: cityList[1] >= 0 && cityList[1] < sugguestCityList.length ? sugguestCityList[cityList[1]].city_code : 0,
            town_code: 0,
          };
          // 1列目 2回目
          tmp = await this.getKindPropertyList(3, this.sugguestProps[0].kind, this.sugguestProps[0].pref_code, this.sugguestProps[0].city_code);
          if (tmp.hit) {
            if (tmp.hit.length > 0) {
              this.sugguestProps[0].count = tmp.found;
              this.sugguestProps[0].list = tmp.hit;
            }
          }
          // 2列目 1回目
          tmp = await this.getKindPropertyList(3, this.sugguestProps[1].kind, this.sugguestProps[1].pref_code, this.sugguestProps[1].city_code);
          if (tmp.hit) {
            if (tmp.hit.length > 0) {
              this.sugguestProps[1].count = tmp.found;
              this.sugguestProps[1].list = tmp.hit;
            }
          }
        } else if (tmp.hit.length > 0) {
          this.sugguestProps[0].count = tmp.found;
          this.sugguestProps[0].list = tmp.hit;
        }
      } else if (this.$route.meta.kind === 2) {
        // 市区町村中古
        this.sugguestProps[0] = {
          kind: 1,
          pref_code: this.storedLocation.pref.code,
          city_code: this.storedLocation.city.code,
          town_code: 0,
        };
        tmp = await this.getKindPropertyList(3, this.sugguestProps[0].kind, this.sugguestProps[0].pref_code, this.sugguestProps[0].city_code);
        if (!tmp.hit) {
          // tmp.lengthが0のとき
          this.sugguestProps[0] = {
            kind: this.$route.meta.kind,
            pref_code: this.storedLocation.pref.code,
            city_code: cityList[0] >= 0 && cityList[0] < sugguestCityList.length ? sugguestCityList[cityList[0]].city_code : 0,
            town_code: 0,
          };
          this.sugguestProps[1] = {
            kind: this.$route.meta.kind,
            pref_code: this.storedLocation.pref.code,
            city_code: cityList[1] >= 0 && cityList[1] < sugguestCityList.length ? sugguestCityList[cityList[1]].city_code : 0,
            town_code: 0,
          };
          // 1列目 2回目
          tmp = await this.getKindPropertyList(3, this.sugguestProps[0].kind, this.sugguestProps[0].pref_code, this.sugguestProps[0].city_code);
          if (tmp.hit) {
            if (tmp.hit.length > 0) {
              this.sugguestProps[0].count = tmp.found;
              this.sugguestProps[0].list = tmp.hit;
            }
          }
          // 2列目 1回目
          tmp = await this.getKindPropertyList(3, this.sugguestProps[1].kind, this.sugguestProps[1].pref_code, this.sugguestProps[1].city_code);
          if (tmp.hit) {
            if (tmp.hit.length > 0) {
              this.sugguestProps[1].count = tmp.found;
              this.sugguestProps[1].list = tmp.hit;
            }
          }
        } else if (tmp.hit.length > 0) {
          this.sugguestProps[0].count = tmp.found;
          this.sugguestProps[0].list = tmp.hit;
        }
      }
    } else if (this.type === 2) {
      // 町域
      let townList = [];
      let sugguestTownList = this.townlist.concat();
      sugguestTownList = sugguestTownList.sort(this.compare);
      sugguestTownList.map((n, m) => {
        if (n.town_code === this.storedLocation.town.code) {
          townList = [m + 1, m - 1];
        }
        return n;
      });
      this.sugguestProps[0] = {
        kind: this.$route.meta.kind,
        pref_code: this.storedLocation.pref.code,
        city_code: this.storedLocation.city.code,
        town_code: townList[0] >= 0 && townList[0] < sugguestTownList.length ? sugguestTownList[townList[0]].town_code : 0,
      };
      this.sugguestProps[1] = {
        kind: this.$route.meta.kind,
        pref_code: this.storedLocation.pref.code,
        city_code: this.storedLocation.city.code,
        town_code: townList[1] >= 0 && townList[1] < sugguestTownList.length ? sugguestTownList[townList[1]].town_code : 0,
      };

      if (this.sugguestProps[0].town_code !== 0) {
        tmp = await this.getKindTownPropertyList(3, this.sugguestProps[0].kind, this.sugguestProps[0].town_code);
        if (tmp.hit) {
          if (tmp.hit.length > 0) {
            this.sugguestProps[0].count = tmp.found;
            this.sugguestProps[0].list = tmp.hit;
          }
        }
      }

      if (this.sugguestProps[1].town_code !== 0) {
        tmp = await this.getKindTownPropertyList(3, this.sugguestProps[1].kind, this.sugguestProps[1].town_code);
        if (tmp.hit) {
          if (tmp.hit.length > 0) {
            this.sugguestProps[1].count = tmp.found;
            this.sugguestProps[1].list = tmp.hit;
          }
        }
      }
    }
  },
  async mounted() {
    if (this.$route.query.map === 'on') this.isMapDisplayFlag = true;
    if (query.zoom !== undefined) this.zoom = parseInt(query.zoom, 10);
    if (process.env.VUE_APP_ENV === 'prod') {
      this.mode = 'prod';
    } else {
      this.mode = 'test';
    }
    if (query.mode !== undefined && (query.mode === 'prod' || query.mode === 'test')) this.mode = query.mode;

    this.optionList = selectOptions;
    this.location = await this.storedLocation;
    this.type = this.location.type;
    this.prefcode = this.location.pref.code.toString();

    // 都道府県/市区町村別処理
    // meta
    if (this.type === 2) {
      // 市区町村
      this.searchArea = this.location.town.name;
      this.pickArea = this.location.town.name;
    } else if (this.type === 1) {
      // 市区町村
      this.searchArea = this.location.city.name;
      this.pickArea = this.location.city.name;
    } else {
      // 都道府県
      this.searchArea = this.location.pref.name;
      this.pickArea = this.location.pref.name;
    }

    // エリア情報スニペット
    let snipet;
    if (this.type === 1) snipet = await this.getAreaRPList(this.location.pref.code, this.location.city.code);
    else snipet = await this.getAreaRPList(this.location.pref.code, 0);

    if (snipet.data.contents.length > 0) {
      this.isAreaInfoDisplay = true;
      this.areaInfo = snipet.data.contents[0];
    }

    // 条件query取得
    // const querystring = window.location.search;
    this.query = [...new URLSearchParams(querystring).entries()]
      .reduce((obj, e) => ({ ...obj, [e[0]]: e[1] }), {});

    /* --検索条件への反映(SearchList) --*/

    if (this.type === 2) {
      // 市区町村
      this.options.code = this.location.town.code;
      this.options.field = 'town_code';
    } else if (this.type === 1) {
      // 市区町村
      this.options.code = this.location.city.code;
      this.options.field = 'city_code';
    } else {
      // 都道府県
      this.options.code = this.location.pref.code;
      this.options.field = 'pref_code';
    }

    // prefcode
    if (this.query.prefcode !== undefined) this.options.prefcode = this.query.prefcode;
    // citycode
    if (this.query.citycode !== undefined) this.options.citycode = this.query.citycode;
    // citycode
    if (this.query.towncode !== undefined) this.options.towncode = this.query.towncode;

    // page
    if (this.query.page !== undefined) this.options.page = this.query.page;
    // size
    if (this.query.size !== undefined) this.options.size = this.query.size;
    // order
    if (this.query.order !== undefined) this.options.order = this.query.order;

    /* --検索条件への反映(SearchListBody) --*/
    // layout
    if (this.query.layout !== undefined) this.options.layout = this.query.layout.split(',');
    // 価格未設定を含む
    if (this.query.ask !== undefined) this.options.ask = true;
    // バス時間を含む
    if (this.query.byBus !== undefined) this.options.byBus = true;
    // フリーワード
    if (this.query.fw !== undefined) this.options.fw = this.query.fw;
    // price
    if (this.query.priceLow !== undefined) this.options.priceLow = this.query.priceLow;
    if (this.query.priceHigh !== undefined) this.options.priceHigh = this.query.priceHigh;
    // landarea
    if (this.query.landAreaLow !== undefined) this.options.landAreaLow = this.query.landAreaLow;
    if (this.query.landAreaHigh !== undefined) this.options.landAreaHigh = this.query.landAreaHigh;
    // buildingarea
    if (this.query.buildingAreaLow !== undefined) this.options.buildingAreaLow = this.query.buildingAreaLow;
    if (this.query.buildingAreaHigh !== undefined) this.options.buildingAreaHigh = this.query.buildingAreaHigh;
    // walkin
    if (this.query.walkin !== undefined) this.options.walkin = this.query.walkin;

    this.isReady = true;
    this.isPropReady = true;

    /* --物件データ取得-- */
    await this.querySearch();

    /* --会員制限-- */
    if (!this.isLoggedIn && this.query.order !== '0' && this.query.order !== undefined) {
      this.directLink = true;
      this.isViewLimited = true;
    }
    this.conditions = this.searchCondition();

    // qa用データセット作成
    if (this.type === 1) {
      this.cityAverageRaw = await this.getCityAverage(this.storedLocation.city.code, this.$route.meta.kind !== 0 ? { kind: this.kindAPI } : {});
      const red = (n, m) => n + m;
      this.cityAverageRaw.count = Object.values(this.cityAverageRaw.data.result.layouts_count).reduce(red);

      this.cityAverageLayoutList = Object.entries(this.cityAverageRaw.data.result.layouts_count).map(([key, value]) => ({ [key]: value }));

      this.cityAverageLayoutList = Object.entries(this.cityAverageRaw.data.result.layouts_count)
        .map(([key, value]) => ({ key, value, per: Math.floor((value / this.cityAverageRaw.count) * 100) }))
        .sort(this.compareCityAverage);

      this.cityAverageObject = {
        price: Math.floor(this.cityAverageRaw.data.result.price_average),
        layoutList: '',
        priceListByLayout: '',
        townList: this.townlist.map(n => n.town_name).concat(),
      };
      if (this.cityAverageObject.townList.length > 5) {
        this.cityAverageObject.townList.length = 5;
      }
      this.cityAverageObject.townList = this.cityAverageObject.townList.join('、');
      this.cityAverageObject.layoutList = `${this.cityAverageLayoutList[0].key}（${this.cityAverageLayoutList[0].per}%)`;
      this.cityAverageLayoutList[0].avg = await this.getCityAverage(this.storedLocation.city.code, this.$route.meta.kind !== 0 ? { kind: this.kindAPI, layout: this.cityAverageLayoutList[0].key } : { layout: this.cityAverageLayoutList[0].key });
      this.cityAverageLayoutList[0].avg = Math.floor(this.cityAverageLayoutList[0].avg.data.result.price_average);
      this.cityAverageObject.priceListByLayout = `${this.cityAverageLayoutList[0].key}は${this.cityAverageLayoutList[0].avg}万円`;
      if (this.cityAverageLayoutList.length >= 2) {
        this.cityAverageObject.layoutList += `、2番目は${this.cityAverageLayoutList[1].key}（${this.cityAverageLayoutList[1].per}%）`;
        this.cityAverageLayoutList[1].avg = await this.getCityAverage(this.storedLocation.city.code, this.$route.meta.kind !== 0 ? { kind: this.kindAPI, layout: this.cityAverageLayoutList[1].key } : { layout: this.cityAverageLayoutList[1].key });
        this.cityAverageLayoutList[1].avg = Math.floor(this.cityAverageLayoutList[1].avg.data.result.price_average);
        this.cityAverageObject.priceListByLayout += `、${this.cityAverageLayoutList[1].key}は${this.cityAverageLayoutList[1].avg}万円`;
      }
      if (this.cityAverageLayoutList.length >= 3) {
        this.cityAverageObject.layoutList += `、3番目は${this.cityAverageLayoutList[2].key}（${this.cityAverageLayoutList[2].per}%）`;
        this.cityAverageLayoutList[2].avg = await this.getCityAverage(this.storedLocation.city.code, this.$route.meta.kind !== 0 ? { kind: this.kindAPI, layout: this.cityAverageLayoutList[2].key } : { layout: this.cityAverageLayoutList[2].key });
        this.cityAverageLayoutList[2].avg = Math.floor(this.cityAverageLayoutList[2].avg.data.result.price_average);
        this.cityAverageObject.priceListByLayout += `、${this.cityAverageLayoutList[2].key}は${this.cityAverageLayoutList[2].avg}万円`;
      }
      this.addJsonLd(this.pickArea, this.kind, this.count, this.cityAverageObject);
    }

    // 構造化MU
    this.addJsonLd(this.pickArea, this.kind, this.count);
  },
  methods: {
    addJsonLd(area, kind, count, avg = null) {
      this.jsonld.mainEntity[0].name = `Q. ${area}の${kind}一戸建て掲載物件数は何件ですか？`;
      this.jsonld.mainEntity[0].acceptedAnswer.text = `A. ミツカルで掲載されている${area}の${kind}一戸建て掲載物件数は${count}件です。希望に沿った物件を探すには、価格帯や間取り、駅からの徒歩時間などの条件で物件を絞り込んでください。`;
      document.querySelectorAll('.js-question')[0].textContent = this.jsonld.mainEntity[0].name;
      document.querySelectorAll('.js-answer')[0].innerHTML = this.jsonld.mainEntity[0].acceptedAnswer.text;
      if (avg !== null) {
        for (let i = 1; i <= 4; i += 1) {
          this.jsonld.mainEntity[i] = {
            '@type': 'Question',
            name: '',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '',
            },
          };
          this.jsonld.mainEntity[i].name = document.querySelectorAll('.js-question')[i].textContent;
          this.jsonld.mainEntity[i].acceptedAnswer.text = document.querySelectorAll('.js-answer')[i].innerHTML;
        }
      }
      this.initialized = true;
    },
    jsonldExport(params) {
      return {
        script: [
          {
            type: 'application/ld+json',
            innerHTML: JSON.stringify(params, null, 2,
            ),
          },
        ],
      };
    },
    onClickMapButton() {
      this.isMapDisplayFlag = !this.isMapDisplayFlag;
      if (this.isMapDisplayFlag) {
        document.querySelector('.p-map').style.display = 'flex';
        this.$router.push({ query: { map: 'on' } });
      } else {
        document.querySelector('.p-map').style.display = 'none';
        this.$router.push({ query: { map: 'off' } });
      }
    },
    async querySearch() {
      let searchUrl;
      if (query.mode === 'prod') {
        searchUrl = 'https://l4goeq8bil.execute-api.ap-northeast-1.amazonaws.com/develop'; // 本番環境
      } else if (query.mode === 'test') {
        searchUrl = 'https://y7dk5n6mq3.execute-api.ap-northeast-1.amazonaws.com/stg';// 開発環境
      } else if (process.env.VUE_APP_ENV === 'prod') {
        searchUrl = 'https://l4goeq8bil.execute-api.ap-northeast-1.amazonaws.com/develop'; // 本番環境
      } else {
        searchUrl = 'https://y7dk5n6mq3.execute-api.ap-northeast-1.amazonaws.com/stg';// 開発環境
      }
      let underPriority = '49';
      let overPriority = '101';
      if (typeof query.under_priority === 'string') {
        underPriority = query.under_priority;
      }
      if (typeof query.over_priority === 'string') {
        overPriority = query.over_priority;
      }
      const p = new Date();
      p.setDate(p.getDate() - 15); // 14日以内
      const provided = `(and+(range+field%3Dprovided_at+%7B'${p.getFullYear()}-${p.getMonth() + 1}-${p.getDate()}T00%3A00%3A00Z'%2C%7D))`;
      let q = '';
      if (query.jp === '1') {
        q = `${searchUrl}?q=(and+(and+(range+field%3D%27priority%27+%7B${underPriority}%2C${overPriority}%7D))+${provided}+(or+(prefix+%27fit%27)+(prefix+%27和楽%27)+(prefix+%27ルバート%27)+(prefix+%27LUSHIE%27)+(prefix+%27Ricca%27)+(prefix+%27クアドリフォリオ%27)+(prefix+%27bighouse%27)+(prefix+%27ZutPLUS＋%27)+(prefix+%27ずっとプラス%27)+(prefix+%27TERRACE%27))+(prefix+`;
      } else {
        q = `${searchUrl}?q=(and+(and+(range+field%3D%27priority%27+%7B${underPriority}%2C${overPriority}%7D))+${provided}+(prefix+`;
      }
      if (this.options.fw === ' ' || this.options.fw === '') q += '%27%27)+';
      else q += `%27${this.options.fw.replace(/\s/, '')}%27)+`;
      q += `(and+${this.options.field}%3A'${this.options.code}')`;
      if (query.jp === '1' || this.$route.meta.kind === 1) {
        // eslint-disable-next-line
        q += "(or+kind%3A'新築')";
      } else if (this.$route.meta.kind === 2) {
        // eslint-disable-next-line
        q += "(or+kind%3A'中古')";
      } else {
        // eslint-disable-next-line
        q += "(or+kind%3A'新築'+kind%3A'中古')";
      }
      if (this.options.ask) {
        q += `(or+(range+field%3D'price_min'+%7B${
          this.options.priceLow * 10000
        }%2C${
          this.options.priceHigh * 10000
        }%7D) (phrase+field=price+'未定'))`;
      } else {
        q += `(and+(range+field%3D'price_min'+%7B${
          this.options.priceLow * 10000
        }%2C${
          this.options.priceHigh * 10000
        }%7D))`;
      }

      q += `(and+(range+field%3D'land_area_min'+%7B${this.options.landAreaLow}%2C${this.options.landAreaHigh}%7D))`;
      q += `(or+(range+field%3D'building_area_min'+%7B${this.options.buildingAreaLow}%2C${this.options.buildingAreaHigh}%7D))`;
      if (this.options.walkin !== '999') {
        if (!this.options.byBus) q += `(and+(range+field%3D'access_time_by_foot_1'+%7B0%2C${this.options.walkin}%7D))`;
        else q += `(or+(range+field%3D'total_access_time_1'+%7B0%2C${this.options.walkin}%7D) (range+field%3D'access_time_by_foot_1'+%7B0%2C${this.options.walkin}%7D))`;
      }
      if (this.options.layout.length > 0) {
        q += '(or';
        for (let i = 0; i < this.options.layout.length; i += 1) {
          if (this.options.layout[i] === '5K') {
            q +=
              '(and+(not+layout_array%3A%27%27)(not+layout_array%3A%271K%27)(not+layout_array%3A%271DK%27)(not+layout_array%3A%271LDK%27)(not+layout_array%3A%272K%27)(not+layout_array%3A%272DK%27)(not+layout_array%3A%272LDK%27)(not+layout_array%3A%273K%27)(not+layout_array%3A%273DK%27)(not+layout_array%3A%273LDK%27)(not+layout_array%3A%274K%27)(not+layout_array%3A%274DK%27)(not+layout_array%3A%274LDK%27))';
          } else {
            q += `(or+layout_array%3A'${this.options.layout[i]}')`;
          }
        }
        q += ')';
      }
      q += ')';
      q +=
        '&q.parser=structured&q.options=%7B%22defaultOperator%22%3A%22and%22%7D&return=_all_fields%2C_score';
      q += `&sort=${this.optionList.sort[this.options.order].field}+${this.optionList.sort[this.options.order].order}`;
      if (this.options.order !== '1') {
        q += ',provided_at+desc'; // 新着順は除外
      }
      q += `&size=${this.options.size}`;
      q += `&start=${(this.options.page - 1) * this.options.size}`;

      // 検索実行
      this.url = q;
      const r = await axios.get(q).then(res => res);
      this.count = r.data.hits.found;
      this.proplist = r.data.hits.hit;

      // 検索履歴
      this.search = this.storedSearchHistory.data;
      if (this.search === null) this.search = [];
      const log = {
        url: location.href,
        pageName: this.searchArea,
        count: 1,
        query: {
          q: window.location.search,
        },
      };

      let searchType;
      switch (this.$route.meta.kind) {
        case 1:
          searchType = AreaSearchType.SHINCHIKU;
          break;
        case 2:
          searchType = AreaSearchType.CHUKO;
          break;
        default:
          searchType = AreaSearchType.ALL;
          break;
      }

      const cityCode = +this.location.city.code;
      const areaLog = {
        prefId: +this.options.prefcode,
        cityId: cityCode,
        townId: +this.location.town.code,
        // 一旦固定で
        searchKind: AreaSearchKind.KODATE,
        searchType,
      };
      await this.setSiteQueryLogs(log, areaLog);

      // 地図座標取得
      this.emptylist = [];
      await this.proplist.map(async (n) => {
        if (
          (n.fields.latitude === undefined && n.fields.longitude === undefined) ||
          (n.fields.latitude.toString() === '0.0' && n.fields.longitude.toString() === '0.0')
        ) {
          let url;
          if (process.env.VUE_APP_ENV === 'prod' || query.mode === 'prod') {
            url = 'https://prod-api.yeah.ki-group.jp/real-estate-properties/';
          } else {
            url = 'https://stg-api.yeah.ki-group.jp/real-estate-properties/';
          }
          // await axios.get(`${url}${n.fields.id}`).then(m => m.data.data);
          // this.accessOpenApi(url, n);
          this.emptylist.push(`${url}${n.fields.id}`);
        } else if (parseInt(n.fields.latitude, 10) !== 0 && parseInt(n.fields.longitude, 10) !== 0) {
          this.coordinateList.push({
            position:
              {
                lat: Number(n.fields.latitude),
                lng: Number(n.fields.longitude),
              },
            id: n.fields.id,
            title: n.fields.name,
            image: n.fields.image,
            price: n.fields.price,
            layout: n.fields.layout,
            area: n.fields.building_area,
            priority: n.fields.priority,
            media: n.fields.media,
          });
        }
      });

      // this.loopAccessOpenApi(this.emptylist);
      this.loop(this.emptylist);

      // 中心座標取得
      if (this.coordinateList.length > 0) {
        this.mapCenterCoordinate = {
          lat: this.coordinateList.map(n => n.position.lat).reduce((a, b) => Number(a) + Number(b)) / this.coordinateList.length,
          lng: this.coordinateList.map(n => n.position.lng).reduce((a, b) => Number(a) + Number(b)) / this.coordinateList.length,
        };
        this.isMapReady = true;
      }
      this.isPagerReady = true;
    },
    searchCondition() {
      const ret = [];
      const _ = this;
      if (this.options.priceLow.toString() !== '0' || this.options.priceHigh.toString() !== '999999999') {
        ret.push({
          name: `価格帯：${selectOptions.priceLow.find(n => n.value.toString() === this.options.priceLow.toString()).name}〜${selectOptions.priceHigh.find(n => n.value.toString() === this.options.priceHigh.toString()).name}`,
          callback() {
            _.options.priceLow = '0';
            _.options.priceHigh = '999999999';
          },
        });
      }
      if (this.options.layout.length > 0) {
        ret.push({
          name: `間取り：${this.options.layout.sort().join(',')}`,
          callback() {
            _.options.layout = [];
          },
        });
      }
      if (this.options.landAreaLow.toString() !== '0' || this.options.landAreaHigh.toString() !== '99999') {
        ret.push({
          name: `土地面積：${selectOptions.areaLow.find(n => n.value.toString() === this.options.landAreaLow.toString()).name}〜${selectOptions.areaHigh.find(n => n.value.toString() === this.options.landAreaHigh.toString()).name}`,
          callback() {
            _.options.landAreaLow = '0';
            _.options.landAreaHigh = '99999';
          },
        });
      }
      if (this.options.buildingAreaLow.toString() !== '0' || this.options.buildingAreaHigh.toString() !== '99999') {
        ret.push({
          name: `建物面積：${selectOptions.areaLow.find(n => n.value.toString() === this.options.buildingAreaLow.toString()).name}〜${selectOptions.areaHigh.find(n => n.value.toString() === this.options.buildingAreaHigh.toString()).name}`,
          callback() {
            _.options.buildingAreaLow = '0';
            _.options.buildingAreaHigh = '99999';
          },
        });
      }
      if (this.options.walkin.toString() !== '999') {
        ret.push({
          name: `徒歩：${selectOptions.walkin.find(n => n.value.toString() === this.options.walkin.toString()).name}`,
          callback() {
            _.options.walkin = '999';
          },
        });
      }
      return ret;
    },
    sleep() {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve();
        }, 100);
      });
    },
    async loop(list) {
      /* eslint no-await-in-loop: 0,no-restricted-syntax: 0 */
      for (const i of list) {
        await axios.get(i)
          .then(response => Promise.resolve(response))
          .catch(() => {
            // console.log(error);
          });
        await this.sleep();
      }
    },
    update(page = 1) {
      let url = location.origin;
      url += '/kodate/';
      if (this.$route.meta.kind === 1) {
        url += 'shinchiku/';
      } else if (this.$route.meta.kind === 2) {
        url += 'chuko/';
      }
      url += `area/${this.options.prefcode}/`;
      if (this.options.citycode !== 0 && this.options.citycode !== '0') url += `${this.options.citycode}/`;

      // page
      url += `?page=${page}`;
      // size
      url += `&size=${this.options.size}`;
      // order
      url += `&order=${this.options.order}`;

      // layout
      if (this.options.layout.length > 0) url += `&layout=${this.options.layout.join()}`;
      // 価格未設定を含む
      if (this.options.ask) url += '&ask=true';
      // バス時間を含む
      if (this.options.byBus) url += '&byBus=true';
      // fw
      if (this.options.fw) url += `&fw=${this.options.fw}`;
      // price
      url += `&priceLow=${this.options.priceLow}`;
      url += `&priceHigh=${this.options.priceHigh}`;
      // landarea
      url += `&landAreaLow=${this.options.landAreaLow}`;
      url += `&landAreaHigh=${this.options.landAreaHigh}`;
      // buildingarea
      url += `&buildingAreaLow=${this.options.buildingAreaLow}`;
      url += `&buildingAreaHigh=${this.options.buildingAreaHigh}`;

      // walkin
      url += `&walkin=${this.options.walkin}`;

      location.href = url;
    },
    viewTrigger() {
      if (this.options.order !== '0' && !this.isLoggedIn) {
        this.isViewLimited = true;
        this.options.order = '0';
      } else {
        this.update();
      }
    },
    resetUrl() {
      let url = location.origin;
      url += `/kodate/area/${this.options.prefcode}/`;
      location.href = url;
    },
    compare(a, b) {
      const genreA = a.city_code;
      const genreB = b.city_code;

      let comparison = 0;
      if (genreA > genreB) {
        comparison = 1;
      } else if (genreA < genreB) {
        comparison = -1;
      }
      return comparison;
    },
    compareCityAverage(a, b) {
      const genreA = a.per;
      const genreB = b.per;

      let comparison = 0;
      if (genreA < genreB) {
        comparison = 1;
      } else if (genreA > genreB) {
        comparison = -1;
      }
      return comparison;
    },
  },
};

</script>

<style scoped lang="scss">

$sp-width: 346px;
$pc-width: 702px;

* {
  font-size: 14px;
}

.p-map {
  position: relative;
  width: calc(100%  - 742px);
  height:calc(100vh - 154px);
  &__blank {
    width: 100%;
    //100%が使えないため100vhからheader+navのheight固定値引き
    height: calc(100vh - 154px);
    background-color: lightgray;
  }
}
.p-list {
  width: 742px;
  height: calc(100vh - 154px);
  overflow:auto;
  background-color: #FAFAFA;
  &__AreaList {
    width: 100%;
    margin: 20px auto 0;

    &__heading {
      width: 100%;
      line-height: 1.3em;
      margin: 0;
      font-weight: bold;
      font-size: 18px;
      text-align: center;
    }
    &__list {
      display: flex;
      flex-wrap: wrap;
      margin-top: 10px;
      padding: 10px;
      &__item {
        margin:10px;
      }
    }
  }
  h1 {
    margin: 20px auto 0;
    font-size: 18px;
    font-weight: bold;
    width: 702px;
  }
  &--condition {
    margin: 30px 15px 20px;
    display: flex;
    flex-wrap: wrap;
    li {
      height: 38px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid #CCC;
      border-radius: 19px;
      padding: 0 20px;
      margin: 0 8px 8px 0;
      background-color: #FFF;
      cursor: pointer;
      img {
        margin-left:  16px;
      }
    }
  }
  &--sortOrderBlock {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 80%;
  }
  &--sort {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 20px auto 12px;
    width: $pc-width;
    &--order {
      display: flex;
      align-items: center;
    }
    &--count {
      font-family: "メイリオ", "Meiryo", sans-serif;
      width: 20%;
      color: #E83532;
      font-size: 16px;
      font-weight: bold;
    }
  }
  &--outline {
    max-width: $pc-width;
    margin: 0 20px;
  }
  &--noprops {
    height: calc(100vh - 719px);
    min-height: 100px;
    padding:0 40px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &--area--outline {
    width: $pc-width;
    margin: 20px auto;
    background: #fff;
  }
  &--breadcrumb--outline {
    width: $pc-width;
    margin: 20px auto;
  }
  &__otherList {
    padding: 20px 0;
  }
  &__otherTitle {
    margin-bottom: 20px;
    font-size: 18px;
    font-weight: bold;
    line-height: 1.5;
    text-align: center;
  }
  &__faq {
    padding: 10px 20px;
  }
  &__faqTitle {
    margin-bottom: 12px;
    font-size: 18px;
    font-weight: bold;
    line-height: 1.5;
    text-align: center;
  }
  &__faqBlock {
    margin-bottom: 10px;
  }
  &__faqQuestion {
    font-size: 13px;
    font-weight: bold;
    line-height: 1.6;
  }
  &__faqAnswer {
    margin-top: 4px;
    font-size: 13px;
    line-height: 1.6;
  }
}

.p-swapDisplay {
  width: 138px;
  height: 52px;
  border: 2px solid #E83532;
  border-radius: 15px;
  background-color: #FFF;
  color: #E83532;
  display: none;
  position: fixed;
  bottom: 112px;
  left: calc(50% - 69px);
  z-index: 120;

  img {
    margin-right: 4px;
    height: 24px;
    width: 24px;
  }

  &:hover {
    opacity: 1;
  }
}

.c-banner {
  display: flex;
  justify-content: center;
  padding: 23px;
  margin: 0 20px;
  border: 1px solid #EFEFEF;
  border-radius: 20px;
  background: #fff;

  &__inner {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  &__title {
    margin-bottom: 17px;
    color: #E83532;
    font-size: 18px;
    font-weight: bold;
  }
  &__text {
    font-size: 14px;
    font-weight: bold;
    line-height: 1.5;
  }
}

.update-button {
  width: 260px !important;
  position:fixed;
  bottom: 170px;
  left: calc(50% - 130px);
  z-index: 130;
}
.u-mT50 {
  margin-top: 50px !important;
}
@media screen and (max-width: 999px) {
  .p-map {
    width: 100vw;
    // height: calc(100vh - 154px);
    display: none;
  }
  .p-list {
    width:100%;
    margin: auto;
    background-color: #FAFAFA;
    h1 {
      width: $pc-width;
      margin: 20px auto;
    }
    &--sort {
      width: $pc-width;
      padding-right: 10px;
      margin: 20px auto;
    }
    &--outline {
      margin: auto;
    }
  }
  .p-swapDisplay {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
}
@media screen and (max-width: 767px)  {
  .p-map {
    width: 100vw;
    height: calc(100vh - 144px);
  }
  .p-list {
    width:100%;
    margin: auto;
    background-color: #FAFAFA;
    h1 {
      max-width: $sp-width;
      max-width: 346px;
      width: 100%;
      padding: 15px 0;
      margin: auto;
      line-height: 1.5em;
    }
    &--condition {
        width: 100%;
        max-width: 346px;
        margin: auto;
      li {
        position: relative;
        justify-content: left;
        width: 100%;
        border:none;
        border-bottom: 1px solid #CCC;
        border-radius: 0;
        padding: 0;
        margin: 0;
        background-color: #FAFAFA;
        img {
          position: absolute;
          right:0px;
        }
      }
    }
    &--sortOrderBlock {
      flex-direction: column;
    }
    &--sort {
      max-width: 100%;
      padding: 0 15px;
      margin: 20px auto;
      flex-wrap: wrap;

      &--count {
        margin-bottom: 36px;
      }

      &--order {
        justify-content: flex-end;
        width: 100%;
        margin-top: 10px;
      }
    }
    &--outline {
      padding: 0 15px;
      max-width: 100%;
      margin: auto;
    }
    &--area--outline {
      width: calc(100% - 30px);
      margin: 20px auto 23px;
    }
    &--breadcrumb--outline {
      padding: 0 15px;
      max-width: 100%;
      margin: 20px auto;
    }
    &__faqTitle {
      text-align: left;
    }
  }
  .p-swapDisplay {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
}

.c-container {
  width:100%;
  display: flex;
  flex-direction: row-reverse;
  .u-selectWrapper {
    width: 180px;
    height: 36px;
    background: #FFF;
    border: 1px solid #CCC;
    border-radius: 18px;
    overflow: hidden;
    position:relative;
    select {
      padding: 0 0 0 20px;
      width: 100%;
      height: 100%;
      font-size: 14px;
      border: 0;
      cursor: pointer;
      appearance: none;
      background: right 10px center no-repeat url(/static/img/icon-sort-4-s.png);
      background-size: 20px 19px;
    }
    &__s{
      width:120px;
    }
  }

  .c-banner {
    display: block;
    &__inner {
      display: block;
    }
    &__title {
      font-size: 16px;
    }
  }
}

</style>
